/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Role_OwnerInputs */

const en_us2_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const pt_br2_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dono`)
};

const es_419_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dueño`)
};

const pt_pt2_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dono`)
};

const fr_fr2_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriétaire`)
};

const de_de2_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaber`)
};

const it_it2_clubs_role_owner = /** @type {(inputs: Clubs_Role_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietario`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Clubs_Role_OwnerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_role_owner = /** @type {((inputs?: Clubs_Role_OwnerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Role_OwnerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_role_owner(inputs)
	if (locale === "es-419") return es_419_clubs_role_owner(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_role_owner(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_role_owner(inputs)
	if (locale === "de-DE") return de_de2_clubs_role_owner(inputs)
	if (locale === "it-IT") return it_it2_clubs_role_owner(inputs)
	return en_us2_clubs_role_owner(inputs)
});
export { clubs_role_owner as "clubs.role_owner" }